import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { ArrowUpRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const HERO_BG = `${API}/api/static/hero/blog.jpg`;

export default function Blog() {
  const { lang, t } = useLang();
  const [posts, setPosts] = React.useState([]);

  React.useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO title="Blog — Panduan Umrah & Haji" titleEn="Blog — Umrah & Hajj Guides" description="Artikel, panduan, dan tips seputar umrah & haji sesuai sunnah dari ustadz dan profesional BATIK Tour." />
      <section className="relative pt-32 lg:pt-40 pb-12 overflow-hidden isolate">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${HERO_BG})` }} aria-hidden />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-background/40" aria-hidden />
        <div className="pointer-events-none absolute bottom-0 inset-x-0 h-24 bg-gradient-to-b from-transparent to-background" aria-hidden />
        <div className="container-x max-w-3xl relative">
          <p className="overline mb-5">{t("sections.blogOver")}</p>
          <h1 className="h-display text-primary">{t("blog.title")}</h1>
          <p className="mt-6 text-lg text-muted-foreground">{t("blog.sub")}</p>
        </div>
      </section>

      <section className="pb-32">
        <div className="container-x grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.id}
              data-testid={`blog-card-${p.slug}`}
              className="group bg-card border border-border rounded-lg overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 anim-fade-up flex flex-col"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <p className="overline mb-3">{p.category} · {p.published_at}</p>
                <h3 className="font-serif text-2xl text-primary leading-snug">{lang === "id" ? p.title_id : p.title_en}</h3>
                <p className="mt-3 text-sm text-muted-foreground line-clamp-3">{lang === "id" ? p.excerpt_id : p.excerpt_en}</p>
                <div className="mt-auto pt-5 flex items-center justify-between border-t border-border mt-6">
                  <span className="text-xs text-muted-foreground">{t("blog.by")} {p.author}</span>
                  <span className="text-primary group-hover:text-accent transition-colors">
                    <ArrowUpRight className="h-5 w-5" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
